import React from "react";
import {css} from 'emotion';
import BounceLoader from 'react-spinners/BounceLoader';
import {colors} from "../styles/theme";

const Pulse = () => {
  return (
    <div className={container}>
      <BounceLoader
        color={colors.accentColor}
        size={16}
      />
    </div>
  )
};

export default Pulse;

const container = css`
  //margin-left: 10px;
`;
